import { render } from "./ListIps.vue?vue&type=template&id=323af285"
import script from "./ListIps.vue?vue&type=script&lang=js"
export * from "./ListIps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__